export default __webpack_public_path__ + "static/media/ship.cc32b62d.png";